import React from 'react';
import { DeckContext } from './DeckContext';

const useSelectedPack = () => {
  const { packSelected = {} } = React.useContext(DeckContext);

  if (!Object.keys(packSelected).length) return {};

  return {
    ...packSelected,
  };
};

export default useSelectedPack;
